import React from "react";

import { Global } from "@emotion/react";
import { styled } from "@mui/material/styles";

import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { Grid, IconButton, Box, Button } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DesktopDrawerHeader from "./DesktopDrawerHeader";
import DrawerTabsContainer from "./DrawerTabsContainer";
import DownloadIcon from "@mui/icons-material/Download";
import { drawerBleeding, drawerWidth } from "../base/theme";

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#1b2021",
}));

function DesktopDrawer({ open, setOpen }) {
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <>
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            width: `calc(${drawerWidth}px - ${drawerBleeding}px)`,
            overflow: "visible",
          },
        }}
      />
      <SwipeableDrawer
        variant="persistent"
        anchor="right"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        disableSwipeToOpen={true}
        hideBackdrop
        ModalProps={{
          keepMounted: true,
        }}
      >
        <StyledBox
          sx={{
            position: "absolute",
            left: -drawerBleeding,
            visibility: "visible",
            right: drawerWidth - drawerBleeding - 1,
            top: 0,
            pointerEvents: "auto",
          }}
        >
          <IconButton
            aria-label={open ? "Close Drawer" : "Open Drawer"}
            disableRipple
            onClick={toggleDrawer(!open)}
          >
            {open ? <ArrowForwardIosIcon /> : <ArrowBackIosNewIcon />}
          </IconButton>
        </StyledBox>
        <StyledBox
          sx={{
            px: 2,
            overflow: "auto",
            height: "80px",
          }}
        >
          <DesktopDrawerHeader />
        </StyledBox>

        <StyledBox sx={{ height: "100%", overflowY: "auto", mb: 5, ml: 4 }}>
          <DrawerTabsContainer />
        </StyledBox>
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            right: 0,
            width: drawerWidth - drawerBleeding,
          }}
        >
          <Grid container spacing={2} sx={{ pl: 3, pr: 3, pb: 2 }}>
            <Grid item xs={6}>
              <Button
                href="https://data.london.gov.uk/dataset/opdc-local-plan-policies-map"
                target="_blank"
                rel="noreferrer"
                startIcon={<DownloadIcon />}
              >
                Download Planning Data
              </Button>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <img
                width={140}
                alt="Mayor of London Logo"
                src="./mayoroflondon.svg"
              />
            </Grid>
          </Grid>
        </Box>
      </SwipeableDrawer>
    </>
  );
}

export default DesktopDrawer;
